module.exports = __webpack_public_path__ + "static/media/browse-electric-vehicles.0bf473d1.svg";